import { render, staticRenderFns } from "./wechat-tips-for-ios.vue?vue&type=template&id=6bf8b9f1&scoped=true"
import script from "./wechat-tips-for-ios.vue?vue&type=script&lang=ts"
export * from "./wechat-tips-for-ios.vue?vue&type=script&lang=ts"
import style0 from "./wechat-tips-for-ios.vue?vue&type=style&index=0&id=6bf8b9f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf8b9f1",
  null
  
)

export default component.exports